import { Box, Flex, Header, Message, TextContent } from 'components';
import './style.scss';

function StageError() {
  return (
    <Flex
      direction='column'
      gap={10}
    >
      <Message type='error'>
        <TextContent element='p'>Похоже, что-то пошло не так...</TextContent>

        <TextContent element='p'>
          Возможные причины:
          <br />
          ▸ Нет рейсов по вашему запросу — проверьте дату и направления.
          <br />
          ▸ Ошибка в данных — убедитесь, что города и даты введены верно.
          <br />▸ Технический сбой — мы уже решаем проблему.
        </TextContent>
        <TextContent element='p'>
          Что можно сделать?
          <br />
          ✔ Изменить параметры поиска — попробуйте другие даты или маршруты.
          <br />✔ Повторить попытку позже — если проблема на нашей стороне, скоро всё заработает.
        </TextContent>
        <TextContent element='p'>
          Спасибо, что выбираете нас! Если нужна помощь — напишите в <a href='mailto:support@zabus.ru'>поддержку</a>.
          🚍💙
        </TextContent>
      </Message>
    </Flex>
  );
}

export default StageError;
